import { ChangeEvent, KeyboardEvent, useState, useMemo, useEffect } from 'react'
import { useIntl } from 'react-intl'

import { useAppDispatch, useAppSelector } from 'app/state'
import { editMapTitleDescription } from 'features/maps/state/mapsSlice'

function useMapTitleEditor() {
  const intl = useIntl()
  const dispatch = useAppDispatch()

  const currentMap = useAppSelector((state) => state.maps.currentMap)
  const [mapTitle, setMapTitle] = useState<string | undefined>(currentMap?.title)

  const mapTitleSpacerContent = useMemo(
    () => (mapTitle ? mapTitle : intl.formatMessage({ id: 'maps.default.title' })),
    [mapTitle, intl]
  )

  useEffect(() => {
    if (mapTitle === undefined && currentMap?.title) {
      setMapTitle(currentMap?.title)
    }
  }, [currentMap, mapTitle, setMapTitle])

  const handleTitleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setMapTitle(event.target.value)
  }

  const saveMapTitle = () => {
    if (currentMap?.id && mapTitle !== undefined) {
      mapTitle !== currentMap.title &&
        dispatch(
          editMapTitleDescription({
            id: currentMap?.id,
            title: mapTitle.trim()
          })
        )
    }
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (event.key === 'Enter' || event.key === 'Tab') {
      saveMapTitle()
      ;(event.target as HTMLInputElement).blur()
    }

    if (event.key === 'Escape') {
      setMapTitle(currentMap?.title)
      ;(event.target as HTMLInputElement).blur()
    }
  }

  const handleTitleSelection = (event) => {
    ;(event.target as HTMLInputElement).select()
  }

  return {
    mapTitle,
    mapTitleSpacerContent,
    handleTitleSelection,
    handleTitleChange,
    handleKeyDown,
    saveMapTitle
  }
}

export default useMapTitleEditor
